import React from "react";
import { StatusEnum } from "../../hoc/with-status";
import { Text } from "../typography";
import {
  Button,
  ButtonSize,
  ButtonVariant,
} from "@amzn/stencil-react-components/button";
import { Col, Row } from "@amzn/stencil-react-components/layout";
import { MessageBanner } from "@amzn/stencil-react-components/message-banner";

interface PICProps {
  status: StatusEnum;
  navigateToUrl: () => void;
  buttonRemove: boolean;
}

export const PIC = ({ status, navigateToUrl, buttonRemove }: PICProps) => {
  return (
    <Col gridGap="1rem">
      {(!status ||
        status === StatusEnum.API_ERROR ||
        status === StatusEnum.INELIGIBLE) && (
        <MessageBanner>
          After you have cleared background check and drug test screenings, you
          will receive instructions via email to complete this form.
        </MessageBanner>
      )}
      <Text>
        Provide information such as address, emergency contacts, and more to
        complete your employee profile before starting working at Amazon.
      </Text>
      {!buttonRemove && (
        <Row gridGap="1rem">
          <Button
            size={ButtonSize.Small}
            variant={ButtonVariant.Primary}
            onClick={navigateToUrl}
          >
            Submit information
          </Button>
        </Row>
      )}
    </Col>
  );
};
